<template lang="pug">
div
  .bg-ws-blue.p-l-1.p-r-1
    a.white--text(:href="`https://www.wintersport.nl/dorpen/${resort.slug}`" :title="`Weer &amp; sneeuw ${resort.name}`" target="_blank") Weer &amp; sneeuwhoogte
  h4.gadget-container
    a.never-visited(:href="`https://www.wintersport.nl/dorpen/${resort.slug}`" :title="resort.name" target="_blank") {{resort.name}}
  a(:href='`https://www.wintersport.nl/dorpen/${resort.slug}`' :title='`Weer & sneeuw ${resort.name}`' target='_blank')
  .gadget-weather
    .day-col(v-for="forecast in resort.forecasts" :key="forecast.hour")
      .day-name {{$dayjs(forecast.realdate).format('dd')}}
      img(:src="`https://static.wintersport.nl/gadget/images/${forecast.icon}.svg`" alt height='20px')
      div(:class="`cl-temp${forecast.temperature}`") {{forecast.temperature}}&deg;
  .p-l-1.p-r-1
    .row
      .col-xs-6
        svg(width='127px' height='54px' viewBox='0 0 127 54' version='1.1' xmlns='http://www.w3.org/2000/svg' xlink='http://www.w3.org/1999/xlink')
          g#ws-info-mtn(stroke='none' stroke-width='1' fill='none' fill-rule='evenodd')
            g#ws-mtn-detail(transform='translate(-1.000000, -3.000000)')
              rect#Rectangle-6(fill='#FFFFFF' x='1' y='3' width='128' height='63')
              text#snowmountain(font-family='ArialMT, Arial' font-size='12' font-weight='normal' fill='#999999')
                tspan(x='92' y='21') {{resort.area.snowheights.maxSnowMountain}}cm
              text#snowvalley(font-family='ArialMT, Arial' font-size='12' font-weight='normal' fill='#999999')
                tspan(x='92' y='52') {{resort.area.snowheights.maxSnowValley}}cm
              path#Page-1(d='M26.3175578,15.3333333 L0.991374331,64.7464193 L71.9764713,64.7464193 L55.6828341,43.122874 L42.4685867,56.2857831 L41.6045573,54.9572604 L48.4788424,48.2362718 L26.3175578,15.3333333 Z M26.6105302,19.7864583 L39.4023325,39.1546423 L32.3034943,32.6123047 L31.0429175,40.6295614 L27.2987445,31.8492839 L24.1919762,40.1276042 L21.7273453,33.1575522 L18.2542482,35.749349 L26.6105302,19.7864583 Z' fill='#DDDDDD')
              path#Line(d='M89.9612205,17.1666667 L29.1357871,17.1666667' stroke='#999999' stroke-linecap='square')
              path#Line-Copy-27(d='M90.1478592,48.1666667 L52.1357871,48.1666667' stroke='#999999' stroke-linecap='square')
              ellipse#Oval-19(stroke='#2F619B' stroke-width='2' fill='#FFFFFF' cx='26.5680934' cy='17' rx='2.0077821' ry='2')
              path#Oval-19-Copy(d='M49.8132296,50 C50.922097,50 51.8210117,49.1045695 51.8210117,48 C51.8210117,46.8954305 50.922097,46 49.8132296,46 C48.7043621,46 47.8054475,46.8954305 47.8054475,48 C47.8054475,49.1045695 48.7043621,50 49.8132296,50 Z' stroke='#2F619B' stroke-width='2' fill='#FFFFFF')
      .col-xs-6.hide-small-gadget
        table.gadget-table
          tbody
            tr
              th Liften
              td(:class="resort.area.snowheights.nodes[0].isResortOpen ? 'success--text' : 'error--text'")  {{resort.area.snowheights.nodes[0].elevatorsOpen}}/{{resort.area.snowheights.nodes[0].elevatorsTotal}}
            tr
              th Pistes
              td(:class="resort.area.snowheights.nodes[0].isResortOpen ? 'success--text' : 'error--text'")  {{resort.area.snowheights.nodes[0].slopeLengthOpen}}/{{resort.area.snowheights.nodes[0].slopeLength}}km

</template>

<script>
import gql from 'graphql-tag';

const query = gql`
	query getResortGadget($slug: String!) {
		resort(slug: $slug) {
			id
			name
			slug
			forecasts(interval: 24, limit: 96) {
				hour
				realdate
				temperature
				icon
			}
			area {
				snowheights(pageInfo: { first: 1 }) {
					maxSnowMountain
					maxSnowValley
					nodes {
						elevatorsTotal
						elevatorsOpen
						slopeLength
						slopeLengthOpen
						isResortOpen
					}
				}
			}
		}
	}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/gadget/resort/:slug',
			'nl-BE': '/gadget/resort/:slug'
		}
	},
	layout: 'empty',
	asyncData({ params, app }) {
		const client = app.$graphClient;

		return client
			.query({
				query: query,
				variables: {
					slug: params.slug
				}
			})
			.then(({ data }) => {
				return data;
			});
	},
	head() {
		return {
			...this.$structuredData(),
			title: this.resort.name,
			link: [
				{
					rel: 'stylesheet',
					href: 'https://static.wintersport.nl/gadget/css/style.css'
				}
			]
		};
	}
};
</script>
